const tabs = [
  {
    id: 'long-term-stock',
    name: 'FBA長期在庫',
    title: 'FBA長期在庫'
  },
  {
    id: 'product-available',
    name: 'セルモンへの出品',
    title: 'セルモンへの出品'
  },
  {
    id: 'settings',
    name: '設定',
    title: '設定'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/salemon-agent-tabs.js